var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35 7A.65.65 0 0 1 7 6.35h10a.65.65 0 1 1 0 1.3H8.57l8.89 8.89a.65.65 0 1 1-.92.92L7.65 8.57V17a.65.65 0 1 1-1.3 0V7Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjM1IDdDNi4zNSA2LjY0MTAyIDYuNjQxMDIgNi4zNSA3IDYuMzVIMTdDMTcuMzU5IDYuMzUgMTcuNjUgNi42NDEwMiAxNy42NSA3QzE3LjY1IDcuMzU4OTkgMTcuMzU5IDcuNjUgMTcgNy42NUg4LjU2OTI0TDE3LjQ1OTYgMTYuNTQwNEMxNy43MTM1IDE2Ljc5NDIgMTcuNzEzNSAxNy4yMDU4IDE3LjQ1OTYgMTcuNDU5NkMxNy4yMDU4IDE3LjcxMzUgMTYuNzk0MiAxNy43MTM1IDE2LjU0MDQgMTcuNDU5Nkw3LjY1IDguNTY5MjRWMTdDNy42NSAxNy4zNTkgNy4zNTg5OSAxNy42NSA3IDE3LjY1QzYuNjQxMDIgMTcuNjUgNi4zNSAxNy4zNTkgNi4zNSAxN1Y3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";